
// 资源库下载弹框
Vue.component("resource_download_modal", {
  props: {},
  data() {
      return {
          visible: false,
          dataSource: [],
          courseId: '',
          authorityType_orignal: false,//原格式权限0
          authorityType_transfer: false,//原格式权限1
          downloadindeterminate: false,
          orignalindeterminate: false,
          transferindeterminate: false,
          downloadcheckAll: false,
          orignalAllChecked: true,
          transferCheckFlag: true,
          transferAllChecked: true
      };
  },
  watch:{
      dataSource:{
          handler(newVal){
              this.selectedInit()
          },
          deep: true,
      }
  },
  computed:{
    selectCount(){
        return this.dataSource.filter(item=>item.transfer.is_selected).length + this.dataSource.filter(item=>item.orignal.is_selected).length 
    }
  },
  methods: {
      async open(courseId) {
          await this.getPermission()
          const that = this
          this.visible = true
          this.courseId = courseId
          API.reqVidoreviewDetail([courseId]).then(res=>{
              if (res && res.success && res.data) {
                  // 根据权限判断是否展示原格式和低质量
                  // console.log(rmanGlobalParameter,'权限！！！！！！')
                  let filearr = [];
                  res.data.forEach((item)=>{
                      let fileGroups = item.fileGroups
                      filearr.push({
                          contentId:item.contentId,
                          downloadAddress:item.downloadAddress,
                          entityName:item.entityName,
                          fileGroups:fileGroups
                      })
                  })
                  let _flag = true
                  const tempObj = filearr.map((item,index)=>{
                      if((!that.authorityType_orignal &&item.fileGroups.length>1) ||  //如果没有原格式 我们规定就必有转码格式并且 允许勾选
                          (that.authorityType_orignal && that.authorityType_transfer && item.fileGroups.length>1 && item.fileGroups[1].files[0].fileSize!==item.fileGroups[0].files[0].fileSize)){
                          _flag = false //这是记录
                      }
                      return item.fileGroups.length>1?{  //说明原格式和转码格式都有
                              orignal:{
                                  ...(item.fileGroups[0].groupName.split('_').length === 1?item.fileGroups[0].files[0]:item.fileGroups[1].files[0]),
                                  entityName:item.entityName,
                                  is_selected:that.authorityType_orignal,//当有权限的时候 初始化默认选中
                                  showName:item.fileGroups[0].groupName.split('_').length === 1?item.fileGroups[0].showName:item.fileGroups[1].showName
                              },
                              transfer:{
                                  ...(item.fileGroups[0].groupName.split('_').length === 1?item.fileGroups[1].files[0]:item.fileGroups[0].files[0]),
                                  entityName:item.entityName,
                                  ifFlag:item.fileGroups[1].files[0].fileSize!==item.fileGroups[0].files[0].fileSize,// 如果转码后文件大小一致则不允许勾选
                                  is_selected:false,//初始化默认不选中
                                  showName:item.fileGroups[0].groupName.split('_').length === 1?item.fileGroups[1].showName:item.fileGroups[0].showName
                              },
                          }:
                          {
                              orignal:{
                                  ...(item.fileGroups[0]?.files[0]),
                                  entityName:item.entityName,
                                  is_selected:true,//初始化默认选中
                                  showName:item.fileGroups[0]?.showName
                              }
                          }
                  })
                  this.transferCheckFlag = _flag
                  this.dataSource = tempObj;//存储数据原对象
              }
          })
      },
      getPermission(){
          const that = this
          return new Promise((resolve,reject)=>{
              API.reqRmanGlobalParam().then(res=>{
                  // console.log(res)
                  if (res.errorCode === 'success' && Array.isArray(res.extendMessage)) {
                      const rmanGlobalParameter = res.extendMessage
                          .filter(item => item.value === "true")
                          .map(item => item.code);
                      that.authorityType_orignal = rmanGlobalParameter.includes('file_group_display')
                      that.authorityType_transfer = rmanGlobalParameter.includes('file_group_proxy_display')
                  }
              }).finally(()=>resolve())
          })
      },
      //设置初始选中
      selectedInit(){
          const that = this
          // console.log('更改了',this.dataSource);
          console.log('原格式权限1',that.authorityType_orignal,that.authorityType_transfer);
          if(!that.authorityType_orignal&&!that.authorityType_transfer) {
              that.downloadCheckAll = false
              return
          };
          console.log('更改了',this.dataSource);
          // debugger
          let orignalFlag = 0
          let transferFlag = 0
          let transferNum = 0
          this.dataSource.map((item,index)=>{
              if(item.orignal.is_selected){
                  orignalFlag++
              }
              if(that.authorityType_orignal){
                  if(item.transfer?.ifFlag){  //有原格式的情形下转码格式的有效个数
                      transferNum++
                  }
              }else{
                  if(item.transfer){  //无原格式的情形下转码格式的有效个数（就是所有有转码格式的都算）
                      transferNum++
                  }
              }
              if(item.transfer?.is_selected){
                  transferFlag++
              }
          })
          // 先判断原格式全选状态
          if(that.authorityType_orignal){
              if(orignalFlag === this.dataSource.length){ //全选
                  that.orignalAllChecked = true
                  that.oignalindeterminate = false
                  if(!that.transferCheckFlag || (that.authorityType_transfer && transferFlag===transferNum)){  //不考虑转码格式勾选情况 以及有转码格式时 他也全勾选了
                      that.downloadCheckAll = true
                      that.downloadindeterminate = false
                  }else{
                      that.downloadCheckAll = false
                      that.downloadIndeterminate = true
                  }
              }else if(orignalFlag === 0){  //一个都没有
                  that.orignalAllChecked = false
                  that.oignalindeterminate = false
                  if(that.transferCheckFlag){
                      that.downloadCheckAll = false
                      that.downloadIndeterminate = false
                  }else{
                      if(transferFlag===0){  //既没有原格式勾选也没有转码格式勾选 则重置全选
                          that.downloadCheckAll = false
                          that.downloadIndeterminate = false
                      }else{
                          that.downloadCheckAll = false
                          that.downloadIndeterminate = true
                      }
                  }
              }else{  // 部分选中
                  that.orignalAllChecked = false
                  that.oignalindeterminate = true
                  that.downloadCheckAll = false
                  that.downloadIndeterminate = true
              }
          }

          // 再判断转码格式全选状态
          if(that.authorityType_transfer){
              if(that.transferCheckFlag){ //转码格式一个都不可选
                  that.transferAllChecked = false
                  that.transferindeterminate = false
                  if(!that.authorityType_orignal){ //如果也没有原格式
                      that.downloadCheckAll = false
                      that.downloadIndeterminate = false
                  }
              }else{
                  if(transferFlag === transferNum){ //全选  要除开原本没有复选框的
                      that.transferAllChecked = true
                      that.transferindeterminate = false
                      if(orignalFlag === this.dataSource.length){  //如果原格式的也全部勾选
                          that.downloadCheckAll = true
                      }else{
                          if(that.authorityType_orignal){  //如果有原格式这一列 那么就半勾选
                              that.downloadCheckAll = false
                              that.downloadIndeterminate = true
                          }else{
                              that.downloadCheckAll = true
                              that.downloadIndeterminate = false
                          }
                      }
                  }else if(transferFlag === 0){  //一个都没有
                      that.transferAllChecked = false
                      that.transferindeterminate = false
                      if(that.authorityType_orignal && orignalFlag !==0){
                          that.downloadCheckAll = false
                          that.downloadIndeterminate = true
                      }else{
                          that.downloadCheckAll = false
                          that.downloadIndeterminate = false
                      }
                  }else{  // 部分选中
                      that.transferAllChecked = false
                      that.transferindeterminate = true
                      that.downloadIndeterminate = true
                  }
              }
          }

          console.log('原格式全选-orignalAllChecked',that.orignalAllChecked)
          console.log('转码格式全选-transferAllChecked',that.transferAllChecked)
          console.log('全选-downloadcheckAll',that.downloadcheckAll)
          this.$forceUpdate()
      },
      // 原格式单选
      onChangeOrignal(checked,temp){
          const that = this
          const sourceDataTemp = JSON.parse(JSON.stringify(that.dataSource))
          if(checked){
              sourceDataTemp.forEach((item)=>{
                  if(item.orignal?.showName === temp.showName && item.orignal?.fileGuid === temp.fileGuid) {
                      // console.log(item,1111)
                      item.orignal.is_selected =true
                  }
              })
              that.dataSource = sourceDataTemp
          }else{
              sourceDataTemp.forEach((item)=>{
                  if(item.orignal?.showName === temp.showName
                      && item.orignal?.fileGuid === temp.fileGuid)
                  {
                      item.orignal.is_selected =false
                  }
              })
              that.dataSource = sourceDataTemp
          }
      },
      // 转码格式单选
      onChangeTansfer(checked,temp){
          const that = this
          const sourceDataTemp = JSON.parse(JSON.stringify(that.dataSource))
          if(checked){
              sourceDataTemp.forEach((item)=>{
                  if(item.transfer?.showName === temp.showName && item.transfer?.fileGuid === temp.fileGuid)
                  {
                      item.transfer.is_selected =true
                  }
              })
              that.dataSource = sourceDataTemp
          }else{
              sourceDataTemp.forEach((item)=>{
                  if(item.transfer?.showName === temp.showName
                      && item.transfer?.fileGuid === temp.fileGuid)
                  {
                      item.transfer.is_selected =false
                  }
              })
              that.dataSource = sourceDataTemp
          }
      },
      // 原格式、转码格式全选切换
      selectSpecial(checked,type){
          //type-0（原格式）type-1（转码格式）
          const that = this
          const sourceDataTemp = JSON.parse(JSON.stringify(that.dataSource))
          if(type === 0){ //原格式全选
              if(checked){
                  that.orignalAllChecked = true
                  sourceDataTemp.forEach((item)=>{
                      item.orignal.is_selected = true;
                  })
                  that.dataSource = sourceDataTemp
              }else{
                  that.orignalAllChecked = false
                  sourceDataTemp.forEach((item)=>{
                      item.orignal.is_selected = false;
                  })
                  if(that.transferCheckFlag){ //不考虑转码格式勾选情况   因为useffect没有触发 不知道为啥 所以要单独处理
                      that.downloadCheckAll = false
                  }else {
                      that.downloadCheckAll = false
                      that.downloadIndeterminate = true
                  }
                  that.dataSource = sourceDataTemp
              }
          }else{   //转码格式全选
              if(checked){
                  that.transferAllChecked = true
                  // setTransferindeterminate(false)
                  sourceDataTemp.forEach((item)=>{
                      if(!that.authorityType_orignal){//如果无原格式权限
                          if(item.transfer){     //有转码格式时
                              item.transfer.is_selected = true;
                          }
                      }else{
                          if(item.transfer?.ifFlag){     //有原格式权限时 且与原格式大小不一致时
                              item.transfer.is_selected = true;
                          }
                      }
                  })
                  that.dataSource = sourceDataTemp
              }else{
                  that.transferAllChecked = false
                  that.transferindeterminate = false
                  sourceDataTemp.forEach((item)=>{//取消勾选则不需要判断详细逻辑了
                      if(item.transfer){
                          item.transfer.is_selected = false;
                      }
                  })
                  that.dataSource = sourceDataTemp
              }
          }
      },
      batchdownload(){
          const that = this
          let index = 0;
          let downloadref = document.createElement("a");
          //由于浏览器对单次批量下载有进程限制（单次最多下载10个的bug），只能使用循环调用了
          const timer =  setInterval(()=>{
              const item = this.dataSource[index];
              if(that.authorityType_orignal){
                  if(item.orignal.is_selected){ //原格式勾选直接下载
                      // console.log('原格式计数',item.orignal.is_selected)
                      downloadref? (downloadref.href = item.orignal.downloadAddress): '';
                      downloadref
                          ? (downloadref.download = `${item.orignal.entityName}_${item.orignal.showName}`)
                          : '';
                      downloadref ? downloadref.click() : '';
                  }
              }
              if(that.authorityType_transfer){
                  if(that.authorityType_orignal){
                      if(item.transfer?.ifFlag && item.transfer.is_selected){ //当有原格式时的转码格式下载
                          // console.log('转码格式计数',item.orignal.is_selected)
                          downloadref
                              ? (downloadref.href = item.transfer.downloadAddress)
                              : '';
                          downloadref
                              ? (downloadref.download = `${item.transfer.entityName}_${item.transfer.showName}`)
                              : '';
                          downloadref ? downloadref.click() : '';
                      }
                  }else{
                      // console.log('计数',item.transfer?.is_selected)
                      if(item.transfer?.is_selected){ //当无原格式时的转码格式下载
                          downloadref
                              ? (downloadref.href = item.transfer.downloadAddress)
                              : '';
                          downloadref
                              ? (downloadref.download = `${item.transfer.entityName}_${item.transfer.showName}`)
                              : '';
                          downloadref ? downloadref.click() : '';
                      }
                  }
              }
              if (index === that.dataSource.length - 1) {
                  clearInterval(timer);
                  that.closemodal();
              }
              index++
          },100);
      },
      // 全选
      ondownloadCheckAllChange(checked){
          if(checked){
              this.dataSource.forEach((item)=>{
                  if(this.authorityType_orignal){ //有原格式下载权限才勾选
                      item.orignal.is_selected = true;
                      if(this.authorityType_transfer && item.transfer?.ifFlag){//有转码格式下载权限 并且与原格式大小不一致才准勾选
                          item.transfer.is_selected=true;
                      }
                  }
                  if(this.authorityType_transfer && item.transfer){//当无原格式时 转码格式就不受原格式大小影响
                      item.transfer.is_selected=true;
                  }
              })
              this.orignalAllChecked = true
              this.transferAllChecked = true
          }else{
              this.dataSource.forEach((item)=>{
                  if(this.authorityType_orignal){ //有原格式下载权限才操作
                      item.orignal.is_selected=false;
                      if(this.authorityType_transfer && item.transfer?.ifFlag){//有转码格式下载权限 并且与原格式大小不一致才准操作
                          item.transfer.is_selected=false;
                      }
                  }
                  if(this.authorityType_transfer && item.transfer){//当无原格式时 转码格式就不受原格式大小影响
                      item.transfer.is_selected=false;
                  }
              })
              this.orignalAllChecked = false
              this.transferAllChecked = false
          }
          this.downloadIndeterminate = false;
          this.downloadCheckAll = checked;
      },
      closemodal(){
        //   this.visible = false
          this.downloadCheckedList = [];
          this.downloadCheckAll = false;
      }
  },
  template: `
      <el-dialog :visible.sync="visible" @closed="closemodal" class="resource_download_modal" title="下载" width="1000px">
          <el-table
              :data="dataSource"
              height="250"
              border
              style="width: 100%">
              <el-table-column
                prop="date"
                :label="$t('素材名')">
                <template slot-scope="scope">
                  <span>{{scope.row.orignal.entityName}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('原格式')">
                <template slot="header">
                  <el-checkbox @change="selectSpecial($event,0)" :indeterminate="orignalindeterminate" :checked="orignalAllChecked">{{$t('原格式')}}</el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox @change="onChangeOrignal($event,scope.row.orignal)" v-model="scope.row.orignal.is_selected">
                  {{'.'+scope.row.orignal.downloadAddress.split('.')[scope.row.orignal.downloadAddress.split('.').length-1].split('?')[0].toUpperCase()+' ('+scope.row.orignal.fileSize+')'}}
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                :label="$t('转码格式')">
                <template slot="header">
                  <el-checkbox @change="selectSpecial($event,1)" :indeterminate="transferindeterminate" :checked="!transferCheckFlag && transferAllChecked">{{$t('转码格式')}}</el-checkbox>
                  <el-tooltip class="item" effect="dark" :content="$t('经转码后，视频形成.MP4文件,音频形成.MP3文件，文档形成.PDF文件，图片形成如.JPG、.PNG等位图格式文件')" placement="top">
                    <iconfont type="iconhollow-question" style="font-size: 18px;margin-top:-4px"></iconfont>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span v-if="!scope.row.transfer || !scope.row.transfer.ifFlag && authorityType_orignal">未转码</span>
                  <el-checkbox v-else @change="onChangeTansfer($event,scope.row.transfer)" v-model="scope.row.transfer.is_selected">
                  {{'.'+scope.row.transfer.downloadAddress.split('.')[scope.row.transfer.downloadAddress.split('.').length-1].split('?')[0].toUpperCase()+' ('+scope.row.transfer.fileSize+')'}}
                  </el-checkbox>
                </template>
              </el-table-column>
          </el-table>
          <div style="text-align:center;margin-top: 20px;">{{$t('已选择个文件', {count: selectCount})}}</div>
          <div slot="footer" align="center">
              <el-button size="middle" type="primary" @click="batchdownload">{{$t('开始下载')}}</el-button>
          </div>
      </el-dialog>
  `,
});